export default "__VITE_ASSET__C9AeUBh6__"